import { render, staticRenderFns } from "./EmpresaRubricas.vue?vue&type=template&id=21be18ea"
import script from "./EmpresaRubricas.vue?vue&type=script&lang=js"
export * from "./EmpresaRubricas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports